import React from 'react'

type SearchFormSectionProps = {
  children: React.ReactNode
  xlGridCols?: '4' | '5'
}

export const SearchFormSection: React.FC<SearchFormSectionProps> = ({ children, ...props }) => {
  const { xlGridCols = '4' } = props

  const xlClassName = xlGridCols === '4' ? 'xl:grid-cols-4' : xlGridCols === '5' ? 'xl:grid-cols-5' : ''

  return (
    <section className={`grid grid-cols-1 gap-x-4 gap-y-8 items-start md:grid-cols-2 lg:grid-cols-3 ${xlClassName}`}>
      {children}
    </section>
  )
}
